export default __webpack_public_path__ + "./assets/logo__503a41570450141d83dd8acffdab60c4.jpg";